"use client";

import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import * as React from "react";
import { useContext } from "react";

import { FilterContext } from "@faire/retailer/components/Filters/FilterContext";
import {
  FilterState,
  useCreateFilterStore,
} from "@faire/retailer/components/Filters/FilterStore";
import { FilterablePaginatedSectionContext } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";

import { useServerCompatibleSDUIFilterablePaginatedSectionState } from "./useServerCompatibleSDUIFilterablePaginatedSectionState";

export const SDUIFilterStoreProviderForRSC: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { updateFilters } =
    useServerCompatibleSDUIFilterablePaginatedSectionState();
  const { startTransition } = useContext(FilterablePaginatedSectionContext);

  const onFilterSelected = (state: FilterState) => {
    const newFilterKeys = getSelectedFilterKeys(state.filterSections);
    startTransition?.(() => updateFilters(newFilterKeys));
  };

  const filterStore = useCreateFilterStore(
    FilterState.build(),
    onFilterSelected
  );

  return (
    <FilterContext.Provider value={filterStore}>
      {children}
    </FilterContext.Provider>
  );
};
